$(function () {
    content.init();
});

var content = {
    selector: '#content_',
    saveSelector: '.content-save',
    getSelector: '.content-get',

    // ckeditor is 750KB and the only thing that needs it is this modal, so it
    // is fetched the first time a pencil is clicked. It used to hang off a
    // @push('scripts') inside the modal partial, which the controller returns
    // on its own, with no layout to render the stack: the tag never reached
    // the page and the admin got four raw textareas.
    editorUrl: 'https://cdn.ckeditor.com/4.22.1/full/ckeditor.js',
    editorRequest: null,

    init: function () {
        content.keepFocusInsideEditorDialogs();

        $(document.body).on('click', content.saveSelector, function () {
            var $modal = $(this).closest('.modal');
            content.updateTextareas($modal);
            $modal.find('form').submit();
        });

        $(document.body).on('click', content.getSelector, function () {
            content.open($(this).data('key'), $(this).data('url'));
        });
    },

    open: function (key, url) {
        var selector = content.selector + key;

        $.get(url, function (html) {
            content.destroyEditors($(selector));
            $(selector).remove();
            $(document.body).prepend(html);

            var $modal = $(selector);

            // Bound before the download finishes: mount() is a no-op until
            // ckeditor is there, and whichever tab is open by then gets built
            // by the call below.
            $modal.on('shown.bs.tab', function (event) {
                content.mount($($(event.target).attr('href')));
            });

            content.show($modal);
            content.loadEditor(function () {
                content.mount($modal.find('.tab-pane.active'));
            });
        });
    },

    show: function ($modal) {
        if (window.bootstrap) {
            // focus:false switches off Bootstrap's focus trap, which otherwise
            // yanks the caret out of ckeditor's dialogs: it appends them to the
            // body, outside the modal.
            bootstrap.Modal.getOrCreateInstance($modal.get(0), {backdrop: 'static', focus: false}).show();
        } else {
            $modal.modal({backdrop: 'static'});
        }
    },

    // One editor per language tab, built when the tab is first shown. ckeditor
    // measures its container on replace(), so building the three hidden ones up
    // front gave them no height until they were resized by hand.
    //
    // The textareas are NOT class="ckeditor": that is ckeditor's own
    // replaceClass, and it replaces everything wearing it the moment the script
    // finishes loading. Since the script now arrives after the modal is on the
    // page, that ran first and built all four with the default configuration,
    // filter and all, which strips the markup out of contents written years ago.
    mount: function ($pane) {
        var textarea = $pane.find('textarea.js-content-editor').get(0);

        if (!textarea || !window.CKEDITOR || CKEDITOR.instances[textarea.id]) {
            return;
        }

        CKEDITOR.replace(textarea, {
            // Nothing is stripped: these blocks are pages written over years and
            // the default filter would quietly throw away the markup it does not
            // recognise the first time one of them is saved.
            allowedContent: true,
            // 4.22.1 is the last freely licensed release and it paints a red
            // "this version is not secure" panel over the text it is editing,
            // which reads as a broken screen. versionCheck is the switch that
            // stops it phoning home for that.
            versionCheck: false
        });
    },

    // The instances outlive the DOM node they were attached to, so reopening
    // the same block twice used to die on "editor instance already exists".
    destroyEditors: function ($modal) {
        content.eachEditor($modal, function (editor) {
            editor.destroy(true);
        });
    },

    updateTextareas: function ($modal) {
        content.eachEditor($modal, function (editor) {
            editor.updateElement();
        });
    },

    eachEditor: function ($modal, callback) {
        $modal.find('textarea.js-content-editor').each(function () {
            var editor = window.CKEDITOR && CKEDITOR.instances[this.id];

            if (editor) {
                callback(editor);
            }
        });
    },

    loadEditor: function (callback) {
        if (window.CKEDITOR) {
            callback();
            return;
        }

        if (!content.editorRequest) {
            content.editorRequest = $.ajax({url: content.editorUrl, dataType: 'script', cache: true});
        }

        content.editorRequest.done(callback);
    },

    // Bootstrap 3 (admin) and 5 (public site) both pull focus back into the
    // open modal on focusin, which leaves ckeditor's link, image and table
    // dialogs impossible to type into.
    keepFocusInsideEditorDialogs: function () {
        $(document).on('focusin', function (event) {
            if ($(event.target).closest('.cke_dialog, .cke_dialog_background_cover, .cke_autocomplete_panel').length) {
                event.stopImmediatePropagation();
            }
        });
    }
};
